import React from 'react';
const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/fXUUDjfUmWwGJKuqwUG3KW/hero-dance.png';

/** Product render: the six Dance Class Ready volumes fanned out on a studio floor. */
export function ProductMockup({
  className = ''
}: {
  className?: string;
}) {
  return <img src={MOCKUP_URL} alt="Dance Class Ready: six spiral-bound volumes, from Volume 01 Start Strong (weeks 1–7) to Volume 06 Show Week & Season Finale (weeks 35–40), on a dance studio floor" width={2048} height={1360} className={`block aspect-[2048/1360] w-full rounded-2xl object-cover shadow-cover ring-1 ring-black/10 ${className}`} data-id="element-236" data-mp="2jllbu7rk8d0n" />;
}